import UpdateResourceInteractor from "../../core/interactor/app/crud/UpdateResourceInteractor";
import Constants from "../common/Constants";

import { IOrganisation } from "../model/Organisation";
import OrganisationMapper from "../service/OrganisationMapper";
import OrganisationParamMapper from "../service/OrgansationParamMapper";

export default class UpdateOrganisationInteractor {
  private updateResource: UpdateResourceInteractor<IOrganisation>;

  constructor({ updateResource }: any) {
    this.updateResource = updateResource;
  }

  async execute(model: IOrganisation) {
    return this.updateResource.execute(
      Constants.organisationsPath,
      OrganisationMapper,
      OrganisationParamMapper,
      model,
      model.id
    );
  }
}
